import { jsx as _jsx } from "react/jsx-runtime";
import { useOverlayContext } from 'seagull/components/OverlayContext/OverlayContext';
import { BulkCreateResultsModal } from '../../../../BulkCreateResultsModal/BulkCreateResultsModal';
import { useTasksDrawer } from '../../../../tasksDrawerStore';
const resultsOf = (task, onReviewDrafts)=>function RunResults(param) {
        let { dismissModal } = param;
        return /*#__PURE__*/ _jsx(BulkCreateResultsModal, {
            runId: task.jobId,
            jobName: task.jobName,
            runCancelled: task.status === 'cancelled',
            onReviewDrafts: onReviewDrafts,
            onClose: ()=>dismissModal(undefined)
        });
    };
export const useOpenCreateRunResults = (task)=>{
    const { showModal } = useOverlayContext();
    const { closeDrawer } = useTasksDrawer();
    return (event)=>{
        event === null || event === void 0 ? void 0 : event.stopPropagation();
        void showModal({
            biName: 'bulk_create_results',
            content: resultsOf(task, closeDrawer)
        });
    };
};
